/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEraser = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13.514 2 6.513 9.155l-1.414 1.44L2 13.774 10.072 22h8.418v-2.039H12.9l.685-.716L22 10.649zm-5.587 8.596 5.587-5.713 5.658 5.766-5.587 5.713zm-3.099 3.177 1.685-1.736 5.658 5.767-1.685 1.735z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEraser as Eraser };
